import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import toast from '$$vueCmp/toast';
import app from '$$app';
import { buildAxiosErrorMeta } from './buildAxiosErrorMeta';

const internalApi = axios.create({
  baseURL: '/api/internal',
});

const api = axios.create({
  baseURL: '/api',
});

const socketInterceptor = req => {
  const methods = ['post', 'put', 'delete'];

  if (methods.includes(req.method)) {
    req.headers.socketId = app.socket?.id || '';
  }

  return req;
};

const requestIdInterceptor = req => {
  const requestId = uuidv4();

  req.headers['X-Request-Id'] = requestId;
  req.meta = req.meta || {};
  req.meta.requestId = requestId;

  return req;
};

const metaInterceptor = req => {
  req.meta = req.meta || {};
  req.meta.requestStartedAt = new Date().getTime();

  if (req.data) {
    req.meta.data = req.data;
  }

  return req;
};

api.interceptors.request.use(requestIdInterceptor);
internalApi.interceptors.request.use(requestIdInterceptor);
api.interceptors.request.use(metaInterceptor);
internalApi.interceptors.request.use(metaInterceptor);

api.interceptors.request.use(socketInterceptor);
internalApi.interceptors.request.use(socketInterceptor);

function enrichAndThrowStoreApiError(error, clientKey) {
  const { meta, errorName, capturedMessage } = buildAxiosErrorMeta(error, clientKey);

  error._meta = meta;
  error._errorName = errorName;
  error._capturedMessage = capturedMessage;
  throw error;
}

internalApi.interceptors.response.use(response => response,
  error => {
    const failUrl = error.config?.url;

    if (failUrl?.includes('/ganttview')) {
      const options = error.response?.status === 502 || error.message === 'Network Error' || error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT' ? { timeout: false } : {};

      toast.error(__('error_tasks_api_operation'), options);
    }
    if (failUrl?.includes('/resources')) {
      toast.error(__('error_tasks_api_operation'));
    }
    if (failUrl?.includes('/custom_columns')) {
      toast.error(__('error_tasks_api_operation'));
    }
    if (failUrl?.includes('/comments')) {
      toast.error(__('error_tasks_api_operation'));
    }

    if (failUrl?.includes('/attachment')) {
      if (error.response?.data.code === 4005) {
        toast.error(__('fileUpload_limitStore', { limit: '' }));
      } else {
        toast.error(__('error_tasks_api_operation'));
      }
    }

    enrichAndThrowStoreApiError(error, 'internalApi');
  });

api.interceptors.response.use(response => response,
  error => {
    const failUrl = error.config?.url;

    if (failUrl?.includes('/task')) {
      toast.error(__('error_tasks_api_operation'));
    }
    if (failUrl?.includes('/link')) {
      toast.error(__('error_tasks_api_operation'));
    }
    if (failUrl?.includes('/resources')) {
      toast.error(__('error_tasks_api_operation'));
    }
    if (failUrl?.includes('/custom_columns')) {
      toast.error(__('error_tasks_api_operation'));
    }
    if (failUrl?.includes('/history')) {
      toast.error(__('error_tasks_api_operation'));
    }

    enrichAndThrowStoreApiError(error, 'api');
  });

// old webix support

const debouncedToastCall = _.debounce(locale => {
  toast.error(locale ? __(locale) : __('error_tasks_api_operation'));
}, 300);

webix.attachEvent('onBeforeAjax', (mode, url, data, request, headers, files, promise) => {
  headers.socketId = app.socket.id || '';
  promise.then(() => {}, () => {
    debouncedToastCall();
  });
});

export {
  internalApi,
  api,
};
